(function () {
  'use strict';

  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  function init() {
    var btn = document.querySelector('.codadevs-back-to-top');
    if (!btn) return;

    var threshold = 600;
    var raf = null;
    function update() {
      btn.classList.toggle('is-visible', window.scrollY > threshold);
      raf = null;
    }
    window.addEventListener('scroll', function () {
      if (raf === null) raf = window.requestAnimationFrame(update);
    }, { passive: true });
    update();

    btn.addEventListener('click', function () {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
